import { Avatar, Typography } from "@mui/material";
import { Circle } from "lucide-react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

const ChatHeader = ({ user }) => {
  if (!user.last_seen) {
    return (
      <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-gray-200">
        <div className="flex items-center gap-3">
          <Avatar
            alt={user.full_name}
            src={user.profile_picture}
            sx={{ width: 42, height: 42 }}
          />
          <div className="flex flex-col">
            <Typography variant="subtitle1" className="text-gray-900" sx={{ fontWeight: 'bold' }}>
              {user.full_name}
            </Typography>
            <Typography variant="caption" className="text-gray-500">
              last seen recently
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  const lastSeen = dayjs(user.last_seen);
  const now = dayjs();

  const isOnline = lastSeen.isValid() && now.diff(lastSeen, "minute") < 2;

  const formatLastSeen = () => {
    if (!lastSeen.isValid()) return "last seen recently";
    if (isOnline) return "online";

    if (lastSeen.isToday()) {
      return `last seen today at ${lastSeen.format("h:mm A")}`;
    }

    if (lastSeen.isYesterday()) {
      return `last seen yesterday at ${lastSeen.format("h:mm A")}`;
    }

    return `last seen ${lastSeen.format("DD/MM/YYYY [at] h:mm A")}`;
  };

  return (
    <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-gray-200">
      <div className="flex items-center gap-3">
        <div className="relative">
          <Avatar
            alt={user.full_name}
            src={user.profile_picture}
            sx={{ width: 42, height: 42 }}
          />

          {/* Online indicator */}
          {isOnline && (
            <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full" />
          )}
        </div>

        <div className="flex flex-col">
          <Typography
            variant="subtitle1"
            className="text-gray-900"
            sx={{
              fontWeight: 'bold'
            }}
          >
            {user.full_name}
          </Typography>

          <Typography
            variant="caption"
            className={`${isOnline ? "text-green-600" : "text-gray-500"
              }`}
          >
            {formatLastSeen()}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;